import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, from } from 'rxjs';
import { environment } from 'src/environments/environment';


//Serives
import { HttpService } from 'src/app/modules/shared/services/http.service';
import { GelAllAccountRequestModel, GetAllAccountsGroupByRequest, SavedFilterData } from '../models/account-request.model';
import { UserAccess } from '../components/accounts-details/models/userAccess';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Tag } from '../models/tag.model';

@Injectable({
    providedIn: 'root'
})

export class AccountServiceN {
    baseAccountURL: string;
    userAccessURL: string;
    documentStorageUrl:string ;
    documentsStorageUrl:string = environment.documentStorageUrl;
    opportunityUrl:string = environment.opportunityUrl;
    accountCasesUrl:string = environment.accountCasesUrl;
    private userAccessSubject = new BehaviorSubject<any[]>([]);
    userAccess$ = this.userAccessSubject.asObservable(); 
    constructor(
        private httpService: HttpService,
        private http: HttpClient
        ) {
        this.baseAccountURL = environment.apiUrlAccount;
        this.documentStorageUrl = environment.integrationMisc;
    }

    getStages(channelId: number, isActive: boolean, filter: string) {
        return this.httpService.getAll(`${this.baseAccountURL}v2/Account/StageWiseCount/Channel/${channelId}?IsActive=${isActive}&filter=${filter}`);
    }

    getStageList(moduleId: number, channelId: number) {
        return this.http.get<any>(`${environment.configUrlV2}/Stage/SelectList/Module/${moduleId}/Channel/${channelId}`);
    }

    createNewAccount(accountData: any): Observable<any> {
        return this.httpService.create(`${this.baseAccountURL}v2/Account`, accountData);
    }
    getVendorNames(requestModel: GelAllAccountRequestModel) {
        const promise =   this.http.get(environment.inventorySalesOrderUrl + 'Vendor/VendorNames?filter='+ `${requestModel.globalSearchValue}`)
            .toPromise()
            return   from(promise);
    }
    getAccountsList(requestModel: GelAllAccountRequestModel){
        return this.httpService.create(`${this.baseAccountURL}v2/Account/GetPagedList`, requestModel);
    }

    getAccountsListWithFilters(requestModel: GelAllAccountRequestModel){
        return this.httpService.create(`${this.baseAccountURL}v2/Account/GetPagedListWithFilter`, requestModel);
    }

    getAccountsGroupList(requestModel: GetAllAccountsGroupByRequest){
        return this.httpService.create(`${this.baseAccountURL}v2/Account/GetGroupedPagedList`, requestModel);
    }

    getUserAccess(accountId: number): Observable<UserAccess[]> {
        return this.httpService.getAll (`${environment.apiUrlAccount}Account/UserHAccess/${accountId}`);
    }

 
    getUserAccessList(accountId: number) {
        this.httpService
          .getAll(`${environment.apiUrlAccount}Account/UserAccess/${accountId}`)
          .subscribe((data) => {
            this.userAccessSubject.next(data); 
          });
      }
    moveAccount(accountData: any): Observable<any> {
        return this.httpService.put(`${this.baseAccountURL}v2/Account/Move`, accountData);
    }


    accountsDocumentsUpload(requesBody):Observable<any[]>{
        return this.httpService.post(this.documentStorageUrl + 'ModuleUpload/Account',requesBody);
    }

    addAccountOpeningBalance(Obj: any,startingdate): Observable<any> {
        return this.http.post<any>(`${environment.apiUrlAccount}AccountInventorySetup/AddAccountOpeningBalance?accountId=${Obj.accountId}&openingBalance=${Obj.openingBalance}&startingDate=${startingdate}`,Obj)
    }

    getAccountDocumentList(requestBody: {
        AccountId: number;
        AccountName: string;
        PageNumber: number;
        PageSize: number;
        LeadId?: number;
    }): Observable<any> {
        const { AccountId, AccountName, PageNumber, PageSize, LeadId } = requestBody;
        const encodedAccountName = encodeURIComponent(AccountName);
        let url = `${this.documentStorageUrl}ModuleUpload/Account?AccountId=${AccountId}&AccountName=${encodedAccountName}&PageNumber=${PageNumber}&PageSize=${PageSize}`;

        if (LeadId) {
            url += `&LeadId=${LeadId}`;
        }

        return this.http.get(url, { observe: 'response' });
    }


    deleteAccountDocument(attachmentId:number){
        return this.httpService.delete(this.documentStorageUrl + `ModuleUpload/${attachmentId}`);
    }

    editAccountDocument(data:{
        attachmentId:number,
        name:string
    }){
        return this.httpService.update(this.documentStorageUrl + "ModuleUpload",data);
    }

    downloadFilesAndFolder(data:{
        id:number;
        isDefaultContentType :boolean
    }):Observable<any>{
        return this.httpService.getById(this.documentStorageUrl + `ModuleUpload/Download/${data?.id}?isDefaultContentType=${data?.isDefaultContentType}`);
    }

    accountEmailValidation(emailAddress: string, accountId: number = 0, leadId: number = 0){
        let params = new HttpParams();
        params = params.append('emailAddress', emailAddress);
        params = params.append('accountid', accountId||0);
        params =  params.append('leadId', leadId||0);

        return this.http.get(`${this.baseAccountURL}v2/Account/EmailValidation`,{ params });
    }

    getAccountOpportunityList(accountId){
        return this.httpService.getAll (`${environment.opportunityUrl}Opportunity/GetStageWiseOpportunities/${accountId}`);
    }

    getAccountCasesList(accountId){
        return this.httpService.getAll (`${environment.accountCasesUrl}Ticket/GetAllTicketByAccountIdWithStages/${accountId}`);
    }

    getAllTags() {
        return this.http.get<any>(`${environment.apiUrlAccount}Tag/All`);
    }

    addTags(tag: Tag): Observable<Tag> {
        return this.http.post<Tag>(environment.apiUrlAccount + 'Tag', tag);
    }

    getAccountPagetListByIds(data:any){
        return this.http.post<any>(`${environment.apiUrlAccount}v2/Account/GetPagedListWithFilterByIds`,data);
    }

    saveFilterDataChannalWise(data: {moduleId: number, channelId: number , filterData: SavedFilterData}){
        return this.http.post<any>(`${environment.configUrlV2 + "/ColumnFilter/"}Module/${data?.moduleId}/Channel/${data?.channelId}`, data?.filterData);
    }

    getSavedFilterDataChannalWise(data: {moduleId: number, channelId: number}){
        return this.http.get<any>(`${environment.configUrlV2 + "/ColumnFilter/"}Module/${data?.moduleId}/Channel/${data?.channelId}`);
    }

    resetSavedFilterChannelWise(data: {moduleId: number, channelId: number}){
        return this.http.delete<any>(`${environment.configUrlV2 + "/ColumnFilter/ResetFilter/"}Module/${data?.moduleId}/Channel/${data?.channelId}`);
    }

    resetSavedGroupByChannelWise(data: {moduleId: number, channelId: number}){
        return this.http.delete<any>(`${environment.configUrlV2 + "/ColumnFilter/ResetGroupBy/"}Module/${data?.moduleId}/Channel/${data?.channelId}`);
    }

    //finance
    getFinance(accountId: number, acctranstypeid: number) {
        return this.http.get<any>(`${environment.financeURl + "FinancialReport/GetAccountFinanceTransaction"}?AccountID=${accountId}&acctranstypeid=${acctranstypeid}`);
    }
    getSalesHistory(accountId,pageNo,pageSize,searchValue){
        let params = new HttpParams();
        params =  params.append('PageNumber', pageNo)
        params =  params.append('PageSize', pageSize)
        params = params.append('searchValue', searchValue)
        return this.http.get<any>(`${environment.financeURl}FinancialReport/GetAccountSalesHistory?accountId=${accountId}`, {observe: 'response', params})
        .toPromise()
            .then(res =>  ({
            data: res.body,
            headers: JSON.parse(res.headers.get('x-pagination'))
        }));
    }

    getAccountsByNameWithHierarchy(channelId: number, searchQuery: string){
        return this.http.get<any>(`${this.baseAccountURL}v2/Account/AccountsByNameWithHierarchy?channelId=${channelId}&search=${searchQuery}`);
    }
}
